import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconInformationTransparent',
  props: {
    className: {},
    classStroke: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: _ctx.size || 22.834,
    viewBox: "0 0 22.834 22.834"
  }, [
    _createElementVNode("path", {
      id: "Path_7851",
      class: _normalizeClass(_ctx.classStroke || 'stroke-zbr-primary'),
      "data-name": "Path 7851",
      d: "M23.434,13.217A10.217,10.217,0,1,1,13.217,3,10.217,10.217,0,0,1,23.434,13.217Z",
      transform: "translate(-1.8 -1.8)",
      fill: "none",
      stroke: "#000",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "2.4"
    }, null, 2),
    _createElementVNode("path", {
      id: "Path_7852",
      class: _normalizeClass(_ctx.classStroke || 'stroke-zbr-primary'),
      "data-name": "Path 7852",
      d: "M18,21.441V18",
      transform: "translate(-6.583 -6.179)",
      fill: "none",
      stroke: "#000",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "2.4"
    }, null, 2),
    _createElementVNode("path", {
      id: "Path_7853",
      class: _normalizeClass(_ctx.classStroke || 'stroke-zbr-primary'),
      "data-name": "Path 7853",
      d: "M18,12h0",
      transform: "translate(-6.583 -4.67)",
      fill: "none",
      stroke: "#000",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "2.4"
    }, null, 2)
  ], 8, _hoisted_1))
}
}

})